import React from 'react';
import Section from '../Layout/Section/Section'
import Wave from '../Dividers/wave';
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';

import './editorial-portrait.scss';
import InnerContainer from '../Layout/InnerContainer/InnerContainer';

function renderBody(block, i) {
  const body = [];

  if (block.body != null) {
    body.push(
      <p key={i} className="body-copy">{block.body}</p>
    );
  }

  return body;
}

function renderBullets(block, key) {
  const listItems = [];

  if (block.bullets) {
    block.bullets.map((item, i) => {
      return listItems.push(
        <li key={i}>{item.bullet}</li>
      )
    })
    
    return <ul className="body-copy">{listItems}</ul>;
  }
}

function renderBlocks(blocks) {
  const allBlocksHTML = [];
  
  blocks.forEach((block, i) => {
    const blockHTML = [];
    if (block.headline || block.body) {
      blockHTML.push(
        <div key={i} className="block">
          {block.headline ? <h3 key={i} className="headline">{block.headline}</h3> : ''}
          {renderBody(block, i)}
          {renderBullets(block, i)}
        </div>
      )
    }

    allBlocksHTML.push(blockHTML);
  })


  return allBlocksHTML;
}

function renderImageOrVideo(image=null, video=null, leftRight) {
  if (image) {
    return <PreviewCompatibleImage customClassName={`cover__image ${leftRight}`} imageInfo={image} alt="cover image" />
  } else if (video) {
    return <video controls width="100%"><source src={video} type="video/mp4" /></video>
  }
}

const EditorialPortrait = ({ image, blocks, video, leftRight="left" }) => {
  return (
    <>
      <Section customClass="editorial-portrait">
        <InnerContainer>
          {renderImageOrVideo(image, video, leftRight)}
          <div className="editorial-portrait__copy-blocks">
            {renderBlocks(blocks)}
          </div>
        </InnerContainer>
        <Wave/>
      </Section>
    </>
  )
}

export default EditorialPortrait
